import React from "react";
import { Global } from "@sourceflow-uk/sourceflow-sdk";
import { SourceFlowHead } from "@sourceflow-uk/sourceflow-head";
import metaObject from "@/.sourceflow/metadata.json";
import sourceflowEnums from "@/sourceflow.enums";
import SimpleContent from "@/components/Shared/SimpleContent";
import SubBanner from "@/components/SubBanner";
import FooterWave from "@/public/site-assets/svg/footer-wave.svg";
import { useRouter } from 'next/router';
import {
    Container,
} from 'reactstrap';
import slugify from 'slugify';

import { router } from "@/routes";
import { useLocale } from "@/hooks/useLocale";
/**
 *
 * @param global
 * @param meta
 * @returns {JSX.Element}
 * @constructor
 */
export default function SubmissionSuccess({
    global,
    meta
}) {
    const locale = useLocale();
    const router = useRouter();

    const urlSlug = slugify(router.route.substring(1), { lower: true });


    // Helper function to capitalize the first letter of each word in a string
    const capitalizeEachWord = (string) => {
        return string.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    };
    // Split the path into breadcrumb parts and exclude the last segment
    const pathParts = router.asPath.split('/').filter(part => part);
    const breadcrumbParts = pathParts.slice(0, -1);

    // Generate breadcrumb elements
    const breadcrumbs = breadcrumbParts.map((part, index) => {
        const href = '/' + breadcrumbParts.slice(0, index + 1).join('/');
        const text = capitalizeEachWord(part.replace(/-/g, ' '));
        return (
            <span key={href}>
                <a href={href}>{text}</a>
            </span>
        );
    });

    // console.log(router.route);
    return (
        <>
            <SourceFlowHead
                metaObject={metaObject}
                title={meta.title}
                description={meta.description}
                canonical={meta.canonical}
            />
            <section className="bg-white">
                <SubBanner
                    global={global}
                    pathPrefix={`${urlSlug}.submission_success.page.sub_banner`}
                    heading={`Form Submission success`}
                    content={<p>Submission Success</p>}
                    breadcrumb_title={<>{breadcrumbs}<span className="active">Thank You</span></>}
                />
                <SimpleContent
                    global={global}
                    pathPrefix={`${urlSlug}.submission_success.page.simple_content`}
                    content={
                        <>
                            <p>Thank you for submitting! We'll get back to you shortly!</p>
                        </>
                    }
                    className={`text-center py-5`}
                    cta_title_1={`Return to jobs`}
                    cta_link_1={`/jobs`}
                    cta_class_1={`tertiaryBtn no-chevron`}
                />
                <div className="pt-5"></div>
                <div className="white footer">
                    <FooterWave />
                </div>
            </section>
        </>
    );
}

/**
 *
 * @returns {Promise<{props: {meta: {description: string, canonical: string, title: string}, jobs: *, global}}>}
 */
export async function getStaticProps() {
    const global = (await Global()).toJson();

    const routerKey = "submission_success";


    return {
        props: {
            global,
            meta: {
                title: `Thank you for submission | Tradewind Recruitment`,
                description: `${sourceflowEnums.seo.genericDescription}`,
                // canonical: sourceflowEnums.seo.baseURL,
                canonical: `${sourceflowEnums.seo.baseURL}${router[routerKey]["en"]}`,
                // alternate: { link: router[routerKey]["en"], lang: "en" },
            }
        },
    };
}

// -- Reference -- //
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflow-head
// https://github.com/sourceflow-uk/components/pkgs/npm/sourceflowtext
// https://github.com/sourceflow-uk/components/pkgs/npm/job-search